module.exports = __webpack_public_path__ + "img/UNITY.19eb209c.svg";